import { render, staticRenderFns } from "./citationStatsTemplateConfig.vue?vue&type=template&id=4c784ca6&scoped=true"
import script from "./citationStatsTemplateConfig.vue?vue&type=script&lang=js"
export * from "./citationStatsTemplateConfig.vue?vue&type=script&lang=js"
import style0 from "./citationStatsTemplateConfig.vue?vue&type=style&index=0&id=4c784ca6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c784ca6",
  null
  
)

export default component.exports